import React from 'react';

export const Twitter = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      height="30"
      width="30"
      viewBox="0 0 30 30"
    >
      <path
        fill="#163e63"
        d="M15 0a15 15 0 1015 15A15 15 0 0015 0zm7.537 12.157c.008.15.008.308.008.465a10.221 10.221 0 01-10.29 10.291 10.087 10.087 0 01-5.528-1.635 6.666 6.666 0 00.863.052 7.264 7.264 0 004.492-1.545 3.611 3.611 0 01-3.375-2.513 3.454 3.454 0 00.683.068 3.622 3.622 0 00.952-.127 3.621 3.621 0 01-2.9-3.548v-.045a3.549 3.549 0 001.635.45A3.614 3.614 0 017.95 9.247a10.256 10.256 0 007.455 3.781 3.294 3.294 0 01-.1-.825 3.618 3.618 0 016.255-2.475 7.356 7.356 0 002.295-.878 3.617 3.617 0 01-1.59 2 7.378 7.378 0 002.078-.571 7.411 7.411 0 01-1.806 1.878z"
      />
    </svg>
  );
};
